import editarTerminalEmpleadosFormModel from './editarTerminalEmpleadosFormModel';
const {
  formField: {
    // DATOS AREA 
    name,
    description,
    typeTerminal
  } 
} = editarTerminalEmpleadosFormModel;

export default {
  [name.name]: '',
  [description.name]: '',
  [typeTerminal.name]: '',
};

